
import React from 'react';
import Button from 'grommet/components/Button';
import Box from 'grommet/components/Box';
import NumberInput from 'grommet/components/NumberInput';
import Label from 'grommet/components/Label';
import {BoxplotChart} from 'prophesier/dist/wrapper/index-with-deps-react.min.js';

class BubbleSample extends React.Component {
    constructor(){
        super();
        this._onChange = this._onChange.bind(this)
        this.state = {sensitivity: 2.5, timeOutFunction: undefined}
    }
    _onClick() {
        this.props.onSubmit()
    }
    //Add a GO button so it does not trigger onChange
    _onChange(event) {
        if (event.persist) event.persist()
        console.log(event.target.value)
        //if (!event.target.value) 
        //console.log(event)
        //console.log(this.timeOutFunction)
        if (this.timeOutFunction) clearTimeout(this.timeOutFunction)
        this.timeOutFunction = setTimeout(()=>{
            console.log("executing")
            
            console.log(event.target.value)
            if (event.target) this.setState({ sensitivity: event.target.value})
        }, 2000)
    }
    render() {
        const {dataNames} = this.props;


        //const dataObjectParsed = this.props.dataObject ? JSON.parse(this.props.dataObject.replace(/(\r\n|\n|\r|\s)/gm,"")) : []
        let finalObjectFiltered = []
        let finalNameFiltered = []

        this.props.dataObject.forEach((input, index) => {
            if (this.props.dataNames[`positiontype${index + 1}`] === "Number") {
                finalObjectFiltered.push(input)
                finalNameFiltered.push(dataNames[`positionname${index+1}`])
            }
        })
        return (
            <div>
                <div style={{display: "flex", justifyContent: "space-between"}}>
                    <h2><strong>Identify Outliers</strong></h2>
                    <Box direction='row'
                        align='center'
                        wrap={true}
                        pad='medium'
                        margin='none'>
                        <Button label='Validate Distributions'
                            type='submit'
                            primary={true}
                            onClick={this._onClick.bind(this)} 
                        />
                    </Box>
                </div>
                <hr style={{width: "100%"}} />
                <div>Red dots represent otuliers (Based on the <a href={"https://en.wikipedia.org/wiki/Interquartile_range"} target="_blank">interquartile range IQR</a>). Reduce distance to increase sensitivity (+/- distance * IQR)</div>
                <Box direction='row'
                    align='center'
                    wrap={true}
                    pad='small'
                    margin='none'>
                    <Label>
                        Distance
                    </Label>
                    <Box direction='row'
                        align='center'
                        wrap={true}
                        pad='small'
                        margin='none'>
                        <NumberInput defaultValue={this.state.sensitivity} step={0.1} onChange={this._onChange.bind(this)} />
                    </Box>
                </Box>
                {finalObjectFiltered.map((element, index)=>{
                    return (
                        <div>
                            <h2>{finalNameFiltered[index]}</h2>
                            <BoxplotChart data={[finalObjectFiltered[index]]} names={finalNameFiltered} sensitivity={this.state.sensitivity}/>
                        </div>
                    )
                })}
                
            </div>
        );
    }
}

export default BubbleSample;


// WEBPACK FOOTER //
// ./src/samples/data/dataoutliers.js